<template>
  <v-app>
    <v-app-bar
      app
      color="#353535"
       elevation="0"
    >
      <div class="d-flex align-center">
        <v-img
          alt="Your First Aid Team Logo"
          class="shrink mr-2"
          contain
          src="@/assets/logo2.png"
          transition="scale-transition"
          width="250"
        />
      </div>

      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>


export default {
  name: 'App',
  data: () => ({
    //
  }),
};
</script>
